import { Button } from "antd";
import "./CustomShelf.css";
import { ICustomShelf } from "./ICustomShelf";

const CustomShelf: React.FC<ICustomShelf> = (props) => {
	return (
		<>
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
			<div
				className={`custom-shelf-backdrop ${props.open ? "open" : ""}`}
				id={"navbar"}
				style={{ position: "fixed" }}
				onClick={props.onClose}
				onKeyDown={(event) => {
					if (event.key === "Enter") {
						props.onClose();
					}
				}}
				aria-hidden={!props.open}
				role="dialog"
				aria-label={props.ariaLabel}
			></div>
			<div className={`custom-shelf ${props.open ? "open" : ""}`} aria-hidden={!props.open}>
				<div className="custom-shelf-close-btn-holder">
					<Button className="custom-shelf-close-btn" htmlType="button" onClick={props.onClose} aria-label={"close"}>
						<span style={{ fontSize: "x-large" }}>X</span>
					</Button>
				</div>
				{props.children}
			</div>
		</>
	);
};

export default CustomShelf;
